module.exports = __webpack_public_path__ + "img/premium-crown.86feccd2.svg";